var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfused1Bg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 134,
    viewBox: "0 0 300 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8769 12.3413C56.8769 14.3866 56.2704 16.3859 55.134 18.0866C53.9977 19.7872 52.3827 21.1126 50.493 21.8953C48.6034 22.678 46.5241 22.8828 44.5181 22.4838C42.5121 22.0848 40.6695 21.0999 39.2232 19.6536C37.777 18.2074 36.7921 16.3648 36.393 14.3587C35.994 12.3527 36.1988 10.2735 36.9815 8.38384C37.7642 6.49422 39.0897 4.87912 40.7903 3.74281C42.4909 2.6065 44.4903 2 46.5356 2C49.2783 2 51.9086 3.08951 53.848 5.02888C55.7873 6.96824 56.8769 9.59859 56.8769 12.3413Z",
    fill: "#45413C",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.0476C0 72.6308 11.5822 79.5595 25.8531 79.5595C40.1241 79.5595 51.7063 72.6308 51.7063 64.0476C51.7063 55.4643 40.1241 48.5357 25.8531 48.5357C11.5822 48.5357 0 55.4643 0 64.0476Z",
    fill: "#FFAA54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.02 12.3413C243.02 14.3866 243.626 16.3859 244.762 18.0866C245.899 19.7872 247.514 21.1126 249.403 21.8953C251.293 22.678 253.372 22.8828 255.378 22.4838C257.384 22.0848 259.227 21.0999 260.673 19.6536C262.119 18.2074 263.104 16.3648 263.503 14.3587C263.902 12.3527 263.698 10.2735 262.915 8.38384C262.132 6.49422 260.807 4.87912 259.106 3.74281C257.405 2.6065 255.406 2 253.361 2C250.618 2 247.988 3.08951 246.048 5.02888C244.109 6.96824 243.02 9.59859 243.02 12.3413Z",
    fill: "#45413C",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.897 64.0476C299.897 72.6308 288.315 79.5595 274.044 79.5595C259.773 79.5595 248.19 72.6308 248.19 64.0476C248.19 55.4643 259.773 48.5357 274.044 48.5357C288.315 48.5357 299.897 55.4643 299.897 64.0476Z",
    fill: "#FFAA54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.059 107.171C180.965 97.8636 139.186 107.171 106.301 131.369",
    stroke: "#45413C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfused1Bg);
export default __webpack_public_path__ + "static/media/confused-1-bg.39f09d2dd6de325f93ac061ad65a7022.svg";
export { ForwardRef as ReactComponent };